<div class="w-full flex flex-col py-5" *ngIf="task">
    <div class="flex flex-row gap-4">
        <div class="w-6/12 ">
            <!-- Estado-->
            <div class="flex gap-5 flex-row w-full items-center py-1">
                <span class="font-bold w-3/12">Estado</span>
                <mat-form-field class="fuse-mat-dense w-9/12">
                    <mat-select
                        id="estado"
                        name="estado"
                        [compareWith]="compareEstados"
                        [disabled]="task.estadoTarea.tipologiaId===tipologiaIdAdmitida || task.estadoTarea.tipologiaId===tipologiaIdRechazada || estadoBloqueado"
                        [(value)]="estadoSeleccionado"
                        (selectionChange)="actualizarEstado(task.tareaUuid, $event.value)">
                        
                        <mat-select-trigger>
                            @if(estadoSeleccionado){
                                <status-sticker [estado]="estadoSeleccionado.descripcion" [color1]="estadoSeleccionado.valor1" [color2]="estadoSeleccionado.valor2"></status-sticker>
                            }
                        </mat-select-trigger>
                
                        @for (estado of estadoTareaList; track estado.tipologiaId) {
                            @if (task.estadoTarea.tipologiaId === ID_ESTADO_GESTION_COMPLETADA 
                                || estado.tipologiaId !== ID_ESTADO_GESTION_COMPLETADA) {
                                <mat-option [value]="estado">
                                    <status-sticker [estado]="estado.descripcion " [color1]="estado.valor1" [color2]="estado.valor2"></status-sticker>
                                    <!--<priority-flag [priority]="prioridad"></priority-flag>-->
                                </mat-option>
                            }
                        }
                
                    </mat-select>
                </mat-form-field>
                
            </div>
     

            <!-- Estado-->
            <div class="flex gap-5 flex-row w-full items-center py-1">
                <span class="font-bold w-3/12">Ingreso</span>
                <span>{{this.task.fechaIngreso | date : 'mediumDate'}}</span>

            </div>

            <!-- Due Date-->
            <div class="flex gap-5 flex-row w-full items-center py-1">
                <span class="font-bold w-3/12">Fecha Límite</span>
                <span>{{this.task.fechaLimite | date : 'mediumDate'}}</span>
                <mat-icon  [svgIcon]="'heroicons_solid:pencil-square'" 
                *hasPermissions="'modificar_fecha_limite' ; modulos ['Tareas']"
                class="icon-size-5 cursor-pointer" 
                (click)="abrirModalFechaLimite()">
            </mat-icon>
            </div>


            <!-- Origen-->
            <div class="flex gap-5 flex-row w-full items-center py-1">
                <span class="font-bold w-3/12">Origen</span>
                <span>{{this.task.origen.descripcion }}</span>
            </div>

            <!-- Correlativo-->
            <div class="flex gap-5 flex-row w-full items-center py-1">
                <span class="font-bold w-3/12">Correlativo</span>
                <span>{{(this.task.correlativo || this.task.tags) | uppercase }}</span>
            </div>
            


        </div>
        <div class="w-6/12">
            <!-- Usuario Asignado-->
            <div class="flex gap-2 flex-row w-full items-center h-[61.5px]">
                <span class="font-bold">Usuario Asignado</span>
                <ng-container *ngFor="let usuario of this.usuariosAsignados$ | async">
                    <div class="relative group flex py-2 ">
                        <button
                            class="cursor-pointer transition-opacity opacity-0 group-hover:opacity-100"
                            (click)="eliminarUsuarioAsignado(usuario)">
                            <mat-icon class="absolute -top-1 -right-3 z-10 cursor-pointer">cancel</mat-icon>
                        </button>
                    
                        <!-- Avatar del usuario -->
                        <user-avatar-name class="group-hover:opacity-50"
                                [name]="usuario.usuarioAsignado?.nombreCompleto">
                        </user-avatar-name>
                    </div>
                </ng-container>
                <add-user-avatar (usuarioSeleccionado)="actualizarUsurioAsignado($event, task.tareaUuid)"></add-user-avatar>  
            </div>

            <!-- Estado-->
            <div class="flex gap-5 flex-row w-full items-center py-1">
                <span class="font-bold">Prioridad</span>
                <button mat-button [matMenuTriggerFor]="menu">  
                    <priority-flag [priority]="this.task.prioridad"></priority-flag>
                </button>
                <mat-menu #menu="matMenu">
                    @for (prioridad of prioridadList; track prioridad.tipologiaId) {
                        <button mat-menu-item (click)="actualizarPrioridad(task.tareaUuid, prioridad)"><priority-flag [priority]="prioridad"></priority-flag></button>
                    }
                </mat-menu>
                
            </div>

            <div class="flex items-center py-2 gap-3">
                <span class="font-bold">Sección:</span>
                <status-sticker [estado]="task.seccion.descripcion" 
                    [color1]="task.seccion.valor1" 
                    [color2]="task.seccion.valor2">
                </status-sticker>
            </div>

        </div>

    </div>

    <div class="w-full flex-col pt-4">
        <textarea (blur)="putDescripcion()" class="w-full border rounded-md p-5" rows="2" [(ngModel)]="task.descripcion"  matInput placeholder="Descripción"></textarea>
    </div>
</div>
